import { Checkbox } from "antd";
import { isMobile } from "../../extensions/design";
import { fmtDateTimeFull } from "../../extensions/utils";

const CompanyItem = ({ item, onClick, isSelected }) => {
  return (
    <div 
      className={`company-item ${isSelected ? 'company-item-selected' : ''}`} 
      onClick={onClick}
    >
      <div className="company-item-header">
        <div className="company-item-name">{item.name || '-'}</div>
        <Checkbox checked={item.active} disabled />
      </div>
      <div className="company-item-body">
        <div className="company-item-line">
          <span className="company-item-label">#</span>
          <span className="company-item-value">{item.id}</span>
        </div>
        <div className="company-item-line">
          <span className="company-item-label">Регистрация</span>
          <span className="company-item-value">{fmtDateTimeFull(item.createdOn) || "-"}</span>
        </div>
        <div className="company-item-line">
          <span className="company-item-label">Домен</span>
          <span className="company-item-value">{item.domain || '-'}</span>
        </div>
        <div className="company-item-line">
          <span className="company-item-label">Комиссия</span>
          <span className="company-item-value">{item.prcComission || 0}%</span>
        </div>
        <div className="company-item-line">
          <span className="company-item-label">Комиссия по договору, %</span>
          <span className="company-item-value">{item.paymentPrc || 0}</span>
        </div>
        {!isMobile && (
          <>
            <div className="company-item-line">
              <span className="company-item-label">Включена</span>
              <Checkbox checked={item.comissionIncluded} disabled />
            </div>
            <div className="company-item-line">
              <span className="company-item-label">GMT</span>
              <span className="company-item-value">{item.gmt || '-'}</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CompanyItem;
